class CollectionLoadMore extends HTMLElement {
  constructor() {
    super();
    this.currentUrl = new URL(window.location.href);
    this.currentPage = this.currentUrl.searchParams.get('page') ? Number(this.currentUrl.searchParams.get('page')) : 1;
    this.handleLoadMoreClick = this.handleLoadMoreClick.bind(this);
    this.button = this.querySelector('[data-plp-load-more]');
    this.totalPages = Number(this.button.dataset.totalPages);
    this.gridContainer = document.querySelector('#product-grid');
    this.gridItemHiddenClass = window.innerWidth > 749 ? 'medium-up-hide' : 'small-hide';
    this.viewPerPage =
      window.innerWidth > 749 ? Number(this.dataset.viewPerPageDesktop) : Number(this.dataset.viewPerPageMobile);
    this.currentMasterTags = [];
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.button.addEventListener('click', this.handleLoadMoreClick);
    this.updateMasterTags();
    this.updateCount();
    this.hideLoadMoreButton();
  }

  async handleLoadMoreClick() {
    await this.loadMoreItems();
    window.ajaxinateCallBack();
    this.updateCount();
    this.hideLoadMoreButton();
  }

  updateCount() {
    const countEl = document.getElementById('load-more__items-count');
    
    if (!countEl) {
      return;
    }

    const visibleItems = this.gridContainer.querySelectorAll(
      `[data-grid-item]:not(.${this.gridItemHiddenClass})`
    );
    const visibleCount = visibleItems.length;
    const totalCount = this.gridContainer.querySelectorAll('[data-grid-item]').length;

    if (/\d+/.test(countEl.textContent)) {
      let occurrence = 0;
      countEl.textContent = countEl.textContent.replace(/\d+/g, () =>
        ++occurrence === 1 ? visibleCount : totalCount
      );
    } else if (window.collectionLoadMoreStrings?.showingItems) {
      countEl.textContent = window.collectionLoadMoreStrings.showingItems
        .replace('[visible]', visibleCount)
        .replace('[total]', totalCount);
    } else {
      countEl.textContent = `Showing ${visibleCount} of ${totalCount} items`;
    }

    const filteredCountEl = document.getElementById('product-count-filtered');
    if (filteredCountEl) {
      if (window.collectionLoadMoreStrings?.productsCount) {
        filteredCountEl.textContent = window.collectionLoadMoreStrings.productsCount.replace('[count]', totalCount);
      } else {
        filteredCountEl.textContent = `${totalCount} Products`;
      }
    }
  }

  async loadMoreItems() {
    let currentHiddenItems = this.getCurrentHiddenItems();

    if (this.checkMoreItemsRequired(currentHiddenItems)) {
      await this.fetchNextCollectionItems(this.currentPage + 1);
      this.updateMasterTags();
      this.currentPage += 1;
      currentHiddenItems = this.getCurrentHiddenItems();

      if (this.checkMoreItemsRequired(currentHiddenItems)) {
        await this.loadMoreItems();
        return;
      }
    }

    const itemsToShow = [...currentHiddenItems].slice(0, this.viewPerPage);
    itemsToShow?.forEach((card) => {
      card.classList.remove(this.gridItemHiddenClass);
    });

    this.updateHistory();
  }

  checkMoreItemsRequired(currentHiddenItems) {
    return currentHiddenItems.length < this.viewPerPage && this.currentPage < Number(this.totalPages);
  }

  getCurrentHiddenItems() {
    return this.gridContainer.querySelectorAll(`[data-grid-item].${this.gridItemHiddenClass}`);
  }

  updateHistory() {
    const itemCountEl = document.getElementById('load-more__items-count');
    window.history.pushState(
      {
        itemHtml: this.gridContainer.innerHTML,
        scroll: window.scrollY,
        itemCountHtml: itemCountEl ? itemCountEl.innerHTML : '',
      },
      '',
      `?page=${this.currentPage}`
    );
  }

  updateMasterTags() {
    const currentVisibleCards = this.gridContainer.querySelectorAll(`[data-grid-item]`);
    this.currentMasterTags = [...currentVisibleCards]?.map((card) => card.getAttribute('data-master-tag'));
  }

  async fetchNextCollectionItems(pageNumber) {
    const disableDistinct = this.gridContainer.getAttribute('data-disable-distinct');
    const { loadingText, defaultText, sectionId, collectionUrl } = this.button.dataset;
    this.button.textContent = loadingText;
    this.button.disabled = true;

    const url = `${collectionUrl}?page=${pageNumber}&section_id=${sectionId}`;

    try {
      const response = await fetch(url);
      const html = await response.text();

      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');
      const newProductGrid = newDocument.querySelector('#product-grid');
      const newCardsItems = newProductGrid.querySelectorAll('[data-grid-item]');

      // Replicating disableDisctinct logic in liquid files
      if (disableDistinct !== 'true') {
        newCardsItems.forEach((card) => {
          if (this.currentMasterTags.includes(card.getAttribute('data-master-tag'))) {
            card.remove();
          }
        });
      }

      const filteredCardsItems = newProductGrid.querySelectorAll('[data-grid-item]');
      filteredCardsItems.forEach((card) => {
        card.classList.add(this.gridItemHiddenClass);
        this.gridContainer.insertAdjacentElement('beforeend', card);
      });
    } catch (error) {
      console.error('Error fetching collection items:', error);
    } finally {
      this.button.textContent = defaultText;
      this.button.disabled = false;
    }
  }

  hideLoadMoreButton() {
    const currentHiddenItems = this.getCurrentHiddenItems();
    if (currentHiddenItems.length === 0 && this.currentPage === Number(this.totalPages)) {
      this.classList.add('hidden');
    }
  }
}

customElements.define('collection-load-more', CollectionLoadMore);
